var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"jira-issue-field-multi-checkboxes"},_vm._l((_vm.options),function(option,idx){return _c('span',{key:option.value},[_vm._v(" "+_vm._s(option.value + (_vm.isLast(idx) ? '' : ', '))+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }